import { connect } from 'react-redux';
import EBookTimeLine from './ebook-timeline.component';

const mapStateToProps = ({ player }) => ({
  ebookData: player.ebookData,
});

export default connect(mapStateToProps)(EBookTimeLine);
